const initState = {

    newCommunication: {
        addRecipientsBy: '',
        availableContactLocations: [],
        availableContacts: [],
        contactsByGroupData: null,
        includesPoll: false,
        message: '',
        pollOptions: ['', ''],
        pollQuestion: '',
        posting: false,
        selectedRecipients: [],
        selectedRecipientType: '',
        sendVoiceCalls: false,
        showAddRecipientsModal: false,
        showReplaceRecipientsWarning: false,
        title: '',
    }
};

export default initState;
